<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} usuario
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Perfil usuario (sistema)<span class="required"></span></label>
                  <select class="form-control" id="profileSelected" required formControlName="profile_id">
                    <option *ngFor="let item of profiles" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-8">
                  <label>Asignar empleado
                    <ng-container *ngIf="employeeSelected == null">
                      (<span class="f-s-11">empleado</span>)
                    </ng-container>
                    <ng-container *ngIf="employeeSelected != null">
                      (<span class="f-s-11">{{employeeSelected.jobassigned}}</span>)
                    </ng-container>
                  </label>
                  <ng-container *ngIf="employeeSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{employeeSelected.fullname}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          (click)="removeEmployee()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="employeeSelected == null">
                    <component-search-employee [classSize]="'search-small'"
                      (selectedEmployeeEvent)="selectedEmployeeSearch($event)" class="w-100">
                    </component-search-employee>
                  </ng-container>
                </div>
                <div class="form-group col-lg-4">
                  <label>Nombre de usuario<span class="required"></span></label>
                  <input type="text" id="user_username" formControlName="username" required class="form-control">
                </div>
                <div class="form-group col-lg-4">
                  <label>Correo electrónico<span class="required"></span></label>
                  <input type="email" id="user_email" class="form-control" formControlName="email">
                </div>
                <div class="form-group col-lg-4">
                  <label>Contraseña<span class="required"></span>
                    <div class="float-right" *ngIf="isEdit" style="margin-bottom: -5px">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="change_password"
                          id="change_password" (change)="activeChangePassword()" [ngModelOptions]="{standalone: true}">
                        <label class="custom-control-label p-t-3 f-s-12" for="change_password">¿Desea
                          cambiar?</label>
                      </div>
                    </div>
                  </label>
                  <input type="password" id="user_password" formControlName="password" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
